import Swal from "sweetalert2";

// Same toast style as the rest of the app, but persistent: this one has to
// stay on screen until the user acts on it.
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: true,
    confirmButtonText: "Reload",
    showCloseButton: true,
    timer: false,
    timerProgressBar: false
});

// The user asked for the new version. Only then may a controllerchange
// reload the page.
let updateConfirmed = false;
// Makes sure we reload at most once.
let refreshing = false;
// One-shot listener registration.
let controllerChangeBound = false;

const reloadOnce = () => {
    if (refreshing) {
        return;
    }
    refreshing = true;
    window.location.reload();
};

const bindControllerChange = () => {
    if (controllerChangeBound || !('serviceWorker' in navigator)) {
        return;
    }
    controllerChangeBound = true;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Never reload behind the user's back: the new worker claims clients
        // on its own, and a silent reload would wipe anything being typed
        // (e.g. in the Social Space composer).
        if (!updateConfirmed) {
            return;
        }
        reloadOnce();
    });
};

// Called by serviceWorkerRegistration when a new service worker has been
// installed and a newer version of the app is ready to be used.
export const onUpdate = (registration) => {
    bindControllerChange();

    Toast.fire({
        icon: "info",
        title: "A new version of OneLike is available"
    }).then((result) => {
        if (!result.isConfirmed) {
            return;
        }

        updateConfirmed = true;

        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        reloadOnce();
    });
};
